import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, withCredentials: true });

http.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("inforno_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const api = {
  login: (email, password) => http.post("/auth/login", { email, password }).then((r) => r.data),
  logout: () => http.post("/auth/logout").then((r) => r.data),
  me: () => http.get("/auth/me").then((r) => r.data),
  changePassword: (b) => http.post("/auth/change-password", b).then((r) => r.data),
  forgotPassword: (email) => http.post("/auth/forgot-password", { email }).then((r) => r.data),
  resetPassword: (b) => http.post("/auth/reset-password", b).then((r) => r.data),
  updateProfile: (b) => http.put("/auth/profile", b).then((r) => r.data),
  config: () => http.get("/config").then((r) => r.data),
  updateFacts: (b) => http.put("/config/facts", b).then((r) => r.data),
  updatePhases: (b) => http.put("/config/phases", { phases: b }).then((r) => r.data),
  today: () => http.get("/today").then((r) => r.data),
  weekly: (o = 0) => http.get(`/weekly-plan?week_offset=${o}`).then((r) => r.data),
  activities: () => http.get("/activities").then((r) => r.data),
  createActivity: (b) => http.post("/activities", b).then((r) => r.data),
  markDone: (id, b) => http.post(`/activities/${id}/mark-done`, b).then((r) => r.data),
  completeRec: (b) => http.post("/activities/complete-recommendation", b).then((r) => r.data),
  updateActivity: (id, b) => http.put(`/activities/${id}`, b).then((r) => r.data),
  delActivity: (id) => http.delete(`/activities/${id}`).then((r) => r.data),
  onboardingSuggestions: () => http.get("/onboarding/suggestions").then((r) => r.data),
  onboardingConfirm: (items) => http.post("/onboarding/confirm", { items }).then((r) => r.data),
  onboardingStatus: () => http.get("/onboarding/status").then((r) => r.data),
  leads: () => http.get("/leads").then((r) => r.data),
  leadsDue: () => http.get("/leads/due").then((r) => r.data),
  createLead: (b) => http.post("/leads", b).then((r) => r.data),
  updateLead: (id, b) => http.put(`/leads/${id}`, b).then((r) => r.data),
  delLead: (id) => http.delete(`/leads/${id}`).then((r) => r.data),
  media: () => http.get("/media").then((r) => r.data),
  uploadMedia: (form) => http.post("/media/upload", form).then((r) => r.data),
  uploadFileChunked: async (file, { category, tags }, onProgress) => {
    const CHUNK = 6 * 1024 * 1024; // 6 MB — safely under Cloudflare's 100 MB request cap
    const uploadId = (window.crypto && window.crypto.randomUUID)
      ? window.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    const total = Math.max(1, Math.ceil(file.size / CHUNK));
    for (let i = 0; i < total; i++) {
      const form = new FormData();
      form.append("upload_id", uploadId);
      form.append("index", String(i));
      form.append("total", String(total));
      form.append("file", file.slice(i * CHUNK, (i + 1) * CHUNK), file.name);
      await http.post("/media/upload/chunk", form);
      if (onProgress) onProgress(Math.round(((i + 1) / total) * 100));
    }
    const cform = new FormData();
    cform.append("upload_id", uploadId);
    cform.append("filename", file.name);
    cform.append("category", category);
    cform.append("tags", tags);
    return http.post("/media/upload/complete", cform).then((r) => r.data);
  },
  updateMedia: (id, b) => http.put(`/media/${id}`, b).then((r) => r.data),
  delMedia: (id) => http.delete(`/media/${id}`).then((r) => r.data),
  copy: () => http.get("/copy").then((r) => r.data),
  createCopy: (b) => http.post("/copy", b).then((r) => r.data),
  updateCopy: (id, b) => http.put(`/copy/${id}`, b).then((r) => r.data),
  delCopy: (id) => http.delete(`/copy/${id}`).then((r) => r.data),
  content: (status) => http.get(`/content${status ? `?status=${status}` : ""}`).then((r) => r.data),
  getContent: (id) => http.get(`/content/${id}`).then((r) => r.data),
  updateContent: (id, b) => http.put(`/content/${id}`, b).then((r) => r.data),
  delContent: (id) => http.delete(`/content/${id}`).then((r) => r.data),
  generate: (b) => http.post("/generate", b).then((r) => r.data),
  transform: (b) => http.post("/generate/transform", b).then((r) => r.data),
  genImage: (b) => http.post("/generate/image", b).then((r) => r.data),
  genReel: (b) => http.post("/generate/reel", b).then((r) => r.data),
};

// Build a download URL that forces a real file download with a useful filename.
export function downloadHref(url, filename) {
  if (!url) return url;
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}download=1&name=${encodeURIComponent(filename)}`;
}

export function assetFilename(kind, label, ext) {
  const d = new Date().toISOString().slice(0, 10);
  const clean = (label || "Asset").replace(/[^a-zA-Z0-9]+/g, "");
  return `Inforno_Thailand2027_${clean}_${d}.${ext}`;
}
